export default {
  data() {
    return {
      openSubmenu: false,
      openSubmenu2: false,
    };
  },
};
